<template>
    <div class="text-caption d-flex align-center flex-wrap text--secondary">
        <div class="font-weight-regular me-1">{{ $t('destination') }}:</div>
        <div v-show="!editDestinationMode">
            <v-progress-circular v-if="destinationsLoading" indeterminate size="24" color="grey" />
            <div v-else class="d-flex align-center">
                <span v-if="destinationLocationsSelectedObjects" class="me-1">
                    <span v-for="(el, i) in destinationLocationsSelectedObjects" :key="el.id">
                        {{ el.cityName || el.countryName }}
                        <span v-if="i !== destinationLocationsSelectedObjects.length - 1"> ,&nbsp; </span>
                    </span>
                </span>
                <v-btn color="grey" size="small" variant="text" icon="mdi-pencil" @click="toggleEditDestinationMode" />
            </div>
        </div>
        <div v-show="editDestinationMode">
            <div class="d-flex align-center">
                <destination-select-autocomplete
                    ref="destinationAutocomplete"
                    v-model="destinationLocationsSelected"
                    dense
                    :disabled="destinationSaveLoading"
                    :item-value="'id'"
                    :_destinations-loading="destinationsLoading"
                    class="destinationAutocomplete"
                    @change-destinations-loading="destinationsLoading = $event"
                    @load-restricted-locations="onDestinationsLoad"
                />
                <v-btn
                    :loading="destinationSaveLoading"
                    icon="mdi-check-circle-outline"
                    variant="text"
                    color="success"
                    class="ms-1 cursor-pointer"
                    @click="saveOrderDestinations"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import DestinationSelectAutocomplete from '@/components/search/forms/DestinationSelectAutocomplete.vue'

    @Component({
        components: {DestinationSelectAutocomplete},
    })
    export class OrderDestinationSelect extends Vue {
        editDestinationMode = false
        destinationLocationsSelected = []
        destinationsLoading = false
        destinationSaveLoading = false
        destinationLocationsSelectedObjects = []

        async mounted() {
            this.loadDestinationLocationsSelected()
        }

        toggleEditDestinationMode() {
            this.editDestinationMode = !this.editDestinationMode
        }

        async saveOrderDestinations() {
            this.destinationSaveLoading = true
            const data = {destinationLocationIds: this.destinationLocationsSelected}
            try {
                await this.$api.orders.put(this.order.orderId, data)
                runtimeStore.SET_ORDER_DETAILS({...this.order, ...data})
            } catch (e) {
                this.$toast.error(this.$t('error_message.save_error'))
            } finally {
                this.loadDestinationLocationsSelected()
                this.destinationSaveLoading = false
                this.editDestinationMode = false
            }
        }

        loadDestinationLocationsSelected() {
            this.destinationLocationsSelected = [...this.order.destinationLocationIds]
            this.onDestinationsLoad(this.$refs.destinationAutocomplete?.destinationLocations)
        }

        onDestinationsLoad(destinationLocations) {
            this.destinationLocationsSelectedObjects = destinationLocations
                ?.filter(d => this.order.destinationLocationIds?.includes(d.id))
                ?.sort((a, b) => (a.cityName || a.countryName)?.localeCompare(b.cityName || b.countryName))
        }

        get order() {
            return runtimeStore.orderDetails
        }
    }

    export default OrderDestinationSelect
</script>

<style scoped lang="scss">
    .destinationAutocomplete {
        width: 300px;
    }
</style>
